const en = {
  // Navigation and General
  companyRegistration: 'Company Registration',
  previous: 'Previous',
  continue: 'Continue',
  submitRegistration: 'Submit Registration',
  reset: 'Reset',

  // Form Steps
  information: 'Information',
  companyInfo: 'Contact Person',
  companyInformation: 'Company Information',
  contact: 'Financial Year',
  businessDetails: 'Representatives',
  confirmation: 'Company Signature',
  bankAndAuth: 'Bank and Authorizations',
  reservations: 'Reservations',
  auditor: 'Auditor',
  otherInfo: 'Other Information',

  // Step Indicators
  step: 'Step',
  of: 'of',

  // Information Step
  informationStepTitle: 'Welcome to the Company Registration Wizard',
  wizardOverview:
    'This step-by-step wizard will guide you through the complete company registration process.',
  registrationProcess: 'Registration Process Overview',
  processSteps: 'You will complete the following steps:',
  stepContactPerson: '1. Contact Person Information',
  stepCompanyInfo: '2. Company Information',
  stepFinancialYear: '3. Financial Year',
  stepRepresentatives: '4. Representatives',
  stepCompanySignature: '5. Company Signature',
  stepOtherInfo: '6. Other Information',
  costInformation: 'Cost Information',
  pdfCost: 'PDF Generation Cost: 399 SEK excluding taxes',
  costDescription:
    'This fee covers the processing and generation of your official company registration PDF document.',
  whatYouReceive: 'What You Will Receive',
  receiveItems: 'Upon completion and payment, you will receive:',
  officialPdf: 'An official PDF document with your company registration information',
  invoiceDocument: 'A detailed invoice for the services provided',
  deliveryMethod: 'Both documents will be sent to your specified email address.',
  getStarted: 'Ready to get started? Click "Continue" to begin the registration process.',

  // Toast Messages
  registrationSubmitted: 'Registration form submitted successfully!',
  pleaseCompleteAllFields: 'Please complete all required fields before submitting.',
  pleaseConfirmSubmission:
    'Please confirm that you are ready to submit by checking the confirmation box.',
  generatingPdf: 'Generating your registration PDF...',
  pdfGenerationError: 'There was an error generating the PDF. Please try again.',
  pdfPreview: 'PDF Preview',
  close: 'Close',
  download: 'Download',
  downloadInvoice: 'Download Invoice',
  loading: 'Loading...',
  downloadInvoiceError: 'Failed to download invoice. Please try again.',
  send: 'Send',

  // Fill defaults checkbox
  fillDefaults: 'Fill with default values',
  fillDefaultsHelp: 'Automatically populate all required fields with sample data for testing',
  fillDefaultsSuccess: 'Form filled with default values',

  // Email functionality
  sendingEmail: 'Sending your PDF by email...',
  emailSent: 'PDF sent successfully to registreraforetag@cerneaconsulting.com',
  emailError: 'Error sending email. Please try again or download the PDF instead.',

  // PDF Preview
  officialForm: 'Official Registration Form',
  downloadingTemplate: 'Downloading the official form template...',
  fillingFormData: 'Filling in your information...',
  templateProcessingError: 'Could not process the official form template. Using fallback format.',

  // Theme
  lightMode: 'Light Mode',
  darkMode: 'Dark Mode',

  // Company Basic Info
  companyBasicInformation: 'Company Basic Information',
  provideBasicInfo: 'Please provide the basic information about your company.',
  companyName: 'Company Name',
  companyNamePlaceholder: 'Enter your company name',
  companyNameHelp: 'The official registered name of your company',
  registrationNumber: 'Registration Number',
  registrationNumberPlaceholder: 'Enter company registration number',
  registrationNumberHelp: 'The official registration number issued by government',
  foundingDate: 'Founding Date',
  foundingDateHelp: 'The date when your company was founded',
  companyType: 'Company Type',
  companyTypePlaceholder: 'Select company type',
  companyTypeHelp: 'The legal structure of your company',
  llc: 'Limited Liability Company (LLC)',
  corporation: 'Corporation',
  partnership: 'Partnership',
  soleProprietorship: 'Sole Proprietorship',
  nonprofit: 'Non-Profit Organization',
  taxNumber: 'Tax Identification Number',
  taxNumberPlaceholder: 'Enter tax ID number',
  taxNumberHelp: "Company's tax identification number",

  // Address Info
  companyAddress: 'Company Address',
  provideAddress: 'Please provide the official registered address of your company.',
  streetAddress: 'Street Address',
  streetAddressPlaceholder: 'Enter street address',
  streetAddressHelp: 'Full street address including building number',
  city: 'City',
  cityPlaceholder: 'Enter city',
  stateRegion: 'State/Province/Region',
  stateRegionPlaceholder: 'Enter state, province or region',
  postalCode: 'Postal Code',
  postalCodePlaceholder: 'Enter postal code',
  country: 'Country',
  countryPlaceholder: 'Select country',
  unitedStates: 'United States',
  canada: 'Canada',
  unitedKingdom: 'United Kingdom',
  germany: 'Germany',
  france: 'France',
  sweden: 'Sweden',
  other: 'Other',

  // Contact Info
  contactInformation: 'Contact Information',
  provideContact: 'Please provide the primary contact details for your company.',
  primaryContactName: 'Primary Contact Name',
  contactNamePlaceholder: 'Enter full name',
  contactNameHelp: 'Primary person to contact for inquiries',
  phoneNumber: 'Phone Number',
  phonePlaceholder: 'Enter phone number',
  phoneHelp: 'Format: +[country code] [number]',
  emailAddress: 'Email Address',
  emailPlaceholder: 'Enter email address',
  companyWebsite: 'Company Website',
  websitePlaceholder: 'https://www.example.com',
  socialMedia: 'Social Media Profiles',
  socialMediaPlaceholder: "List your company's social media accounts (one per line)",
  socialMediaHelp: 'LinkedIn, Twitter, Facebook, etc.',

  // Business Info
  businessDetailsTitle: 'Business Details',
  provideBusinessInfo: 'Please provide information about your business operations.',
  industry: 'Industry',
  industryPlaceholder: 'Select your industry',
  technology: 'Technology',
  manufacturing: 'Manufacturing',
  retail: 'Retail',
  healthcare: 'Healthcare',
  financialServices: 'Financial Services',
  education: 'Education',
  numberOfEmployees: 'Number of Employees',
  employeesPlaceholder: 'Select employee range',
  annualRevenue: 'Annual Revenue',
  revenuePlaceholder: 'Select revenue range',
  lessAmount: 'Less than $100,000',
  amount100k: '$100,000 - $500,000',
  amount500k: '$500,000 - $1 million',
  amount1m: '$1 million - $10 million',
  amount10m: '$10 million+',
  businessDescription: 'Business Description',
  descriptionPlaceholder: 'Describe your business operations and services',
  descriptionHelp: 'Minimum 50 characters describing your business operations',
  registeredCapital: 'Registered Capital',
  capitalPlaceholder: 'Enter amount in USD',
  capitalHelp: 'The amount of capital registered with authorities (e.g. $10,000.00)',

  // Confirmation
  reviewAndConfirm: 'Review and Confirm',
  reviewPrompt: 'Please review all entered information and confirm that it is correct.',
  legalAgreements: 'Legal Agreements',
  acceptTerms: 'I accept the Terms and Conditions',
  termsHelp:
    'By checking this box, I acknowledge that I have read and agree to the Terms and Conditions.',
  acceptPrivacy: 'I accept the Privacy Policy',
  privacyHelp:
    'By checking this box, I acknowledge that I have read and agree to the Privacy Policy.',
  confirmComplete: 'I confirm all information is complete and accurate',
  completeHelp:
    'By checking this box, I certify that all information provided is true and accurate.',
  readyToSubmit: 'I am ready to submit my registration',
  submitHelp: 'By checking this box, I confirm that I am ready to submit this registration form.',
  digitalSignature: 'Digital Signature',
  signaturePlaceholder: 'Your full name',
  signatureHelp: 'By typing your name, you agree this constitutes a legal digital signature.',

  // PDF Pricing and Terms Dialog
  pdfPricingInfo:
    'The official PDF registration document will be generated with a processing fee of 399 SEK excluding taxes. This includes all necessary forms and official documentation required for company registration.',
  termsDialogTitle: 'Terms and Conditions',
  termsDialogContent:
    'By accepting these terms and conditions, you agree to the following: 1) All information provided is accurate and complete. 2) You understand the legal requirements for company registration. 3) You agree to pay the associated fees for processing and documentation. 4) You acknowledge that false information may result in rejection of your application. 5) All personal data will be processed according to GDPR regulations and our privacy policy.',

  // Delivery Email
  deliveryEmailLabel: 'Email address for document delivery',
  deliveryEmailPlaceholder: 'Enter email address where documents should be sent',
  deliveryEmailHelp: 'This is where the completed registration documents will be sent',

  // Other Info Text
  otherInfoTextLabel: 'Additional information for email',
  otherInfoTextPlaceholder:
    'Enter any additional information that should be included directly in the email text...',
  otherInfoTextHelp:
    'This text will be sent directly in the email body, not included in the PDF document',

  // Validation Messages
  fieldRequired: 'This field is required',
  nameMinLength: 'Company name must be at least 3 characters',
  nameMaxLength: 'Company name must be less than 100 characters',
  contactNameMinLength: 'Contact name must be at least 3 characters',
  addressMinLength: 'Street address must be at least 5 characters',
  invalidCity: 'City should only contain letters, spaces and hyphens',
  invalidPostalCode: 'Invalid postal code format',
  invalidPhone: 'Invalid phone number format',
  invalidEmail: 'Invalid email address',
  invalidWebsite: 'Invalid website URL',
  descriptionMinLength: 'Business description must be at least 50 characters',
  invalidMonetary: 'Invalid monetary format',
  futureDateError: 'Founding date cannot be in the future',
  invalidRegNumber: 'Registration number can only contain letters, numbers, and hyphens',
  invalidTaxNumber: 'Tax number can only contain letters, numbers, and hyphens',

  // Language Selection
  language: 'Language',
  english: 'English',
  swedish: 'Swedish',

  // Contact Person
  contactPersonTitle: 'Contact Person',
  contactPersonDesc:
    'The contact person is the orderer and the one to whom we send contracts and other documents. It does not have to be the same person as the buyer of the company.',
  registeredIn: 'Registered in',
  personalId: 'Personal ID number (YYYYMMDD-XXXX)',
  citizenshipOtherCountry: 'Citizenship in another country?',
  specifyCountries: 'Specify which countries',
  firstName: 'First name',
  lastName: 'Last name',
  companyOrderer: 'Company name (if the orderer is a company)',
  companyOrdererHelp:
    'Only fill this in if the contact person is at a company and we should send the mail there.',
  careOf: 'c/o',
  phoneRequired: 'Phone number must be provided',
  mobile: 'Mobile',

  // Wizard Page Descriptions and New Labels
  companyInformationDesc: 'Company Information (Bolagsuppgifter)',
  financialYearDesc: 'Financial Year (Räkenskapsår)',
  financialYearStart: 'Financial year start',
  financialYearEnd: 'Financial year end',

  // Financial Year Page - English translations
  financialYearTitle: 'Financial Year',
  financialYearDescription:
    'Specify your desired financial year. For most companies, the calendar year (January 1 - December 31) works best. For those with different requirements, you can choose any financial year here:',
  financialYearStandard1: 'January 1 - December 31',
  financialYearStandard2: 'May 1 - April 30',
  financialYearStandard3: 'July 1 - June 30',
  financialYearStandard4: 'September 1 - August 31',
  financialYearSpecial: 'Special financial year (+895 SEK)',
  financialYearCustomLabel: 'Choose another financial year',
  financialYearCustom1: 'February 1 - January 31',
  financialYearCustom2: 'March 1 - February 28/29',
  financialYearCustom3: 'April 1 - March 31',
  financialYearCustom4: 'June 1 - May 31',
  financialYearCustom5: 'August 1 - July 31',
  financialYearCustom6: 'October 1 - September 30',
  financialYearCustom7: 'November 1 - October 31',
  financialYearCustom8: 'December 1 - November 30',
  financialYearNotice:
    'Note: Your desired financial year is not in stock and will be ordered. This means the processing time will be longer than normal.',
  representativesDesc: 'Representatives (Företrädare)',
  ceo: 'CEO',
  boardMembersLabel: 'Board members (one per line)',

  // Share Capital
  shareCapitalTitle: 'Share Capital',
  shareCapitalDescription:
    'We keep companies with 25,000 kr and 50,000 kr in share capital in stock. If you want a different share capital, check the box below. The issue can be used for example to get three owners to get equal share. Issue can be used, for example, so that three owners get an equal share of the company.',
  shareCapital25k: '25,000 kr - (250 shares)',
  shareCapital50k: '50,000 kr - (500 shares)',
  orderHigherCapital: 'Order higher share capital, new issue (+695 kr)',
  orderShareSplit: 'Order higher number of shares, share split (+395 kr)',

  // Owners and Representatives
  ownersAndRepresentatives: 'Owners and Representatives',
  ownersDescription:
    "Here you add who will own the company, as well as the company's representatives, such as board members, deputy MD, etc. Shareholders and board members are often the same person, but the deputy cannot be the same as the board member. Under the table you specify which share capital you want and how many shares.",
  companyNeedsMinimum: 'A company needs at least one owner, one board member and one deputy.',
  roleColumn: 'Role',
  nameColumn: 'Name',
  addressColumn: 'Address',
  changeColumn: 'Change',
  removeColumn: 'Remove',
  shareholder: 'Shareholder',
  boardMember: 'Board Member',
  boardDeputy: 'Board Deputy',
  addOwnerRepresentative: 'Add owner / representative',
  companySignatureDesc: 'Company Signature (Firmateckning)',
  companySignatureTitle: 'Company Signature',
  companySignatureDescription: 'Specify below who should have the right to sign the company.',
  signatureBoard: 'Signed by the board',
  signatureCustom: 'Company signed by the board or as follows:',
  signatureDetailsPlaceholder: 'Enter specific signature requirements...',
  signatureType: 'Signature type',
  signatureTypePlaceholder: 'Select signature type',
  signatureSingle: 'Single signer',
  signatureJoint: 'Joint signers',
  signatureAnyTwo: 'Any two signers',
  signatoriesLabel: 'Signatories (one per line)',

  // Contact Section
  contactSection: 'Do you need assistance, please contact us:',

  // Add Representative Dialog
  addOwnerRepresentativeTitle: 'Add Owner / Representative',
  addToLabel: 'Add to',
  newPersonPlaceholder: 'New person...',
  newPerson: 'New person...',
  asRoleLabel: 'as',
  personalDetailsTitle: 'Personal Details',
  personalIdFormat: 'Personal ID number (12 digits, YYYYMMDD-XXXX)',
  sharesTitle: 'Shares',
  numberOfSharesLabel: 'Number of shares',
  ofTotal: 'of total',
  cancel: 'Cancel',
  addButton: 'Add',

  // Role options
  roles: {
    shareholder: 'Shareholder',
    boardMember: 'Board Member',
    boardDeputy: 'Board Deputy',
    ceo: 'CEO',
    viceCeo: 'Vice CEO',
    externalSignatory: 'External Signatory',
    authorizingPerson: 'Authorizing Person',
  },

  // Countries
  countries: {
    afghanistan: 'Afghanistan',
    albania: 'Albania',
    algeria: 'Algeria',
    andorra: 'Andorra',
    angola: 'Angola',
    antiguaAndBarbuda: 'Antigua and Barbuda',
    argentina: 'Argentina',
    armenia: 'Armenia',
    australia: 'Australia',
    austria: 'Austria',
    azerbaijan: 'Azerbaijan',
    bahamas: 'Bahamas',
    bahrain: 'Bahrain',
    bangladesh: 'Bangladesh',
    barbados: 'Barbados',
    belarus: 'Belarus',
    belgium: 'Belgium',
    belize: 'Belize',
    benin: 'Benin',
    bhutan: 'Bhutan',
    bolivia: 'Bolivia',
    bosniaAndHerzegovina: 'Bosnia and Herzegovina',
    botswana: 'Botswana',
    brazil: 'Brazil',
    brunei: 'Brunei',
    bulgaria: 'Bulgaria',
    burkinaFaso: 'Burkina Faso',
    burundi: 'Burundi',
    caboVerde: 'Cabo Verde',
    cambodia: 'Cambodia',
    cameroon: 'Cameroon',
    canada: 'Canada',
    centralAfricanRepublic: 'Central African Republic',
    chad: 'Chad',
    chile: 'Chile',
    china: 'China',
    colombia: 'Colombia',
    comoros: 'Comoros',
    congo: 'Congo',
    costaRica: 'Costa Rica',
    coteDIvoire: "Côte d'Ivoire",
    croatia: 'Croatia',
    cuba: 'Cuba',
    cyprus: 'Cyprus',
    czechRepublic: 'Czech Republic',
    democraticRepublicOfTheCongo: 'Democratic Republic of the Congo',
    denmark: 'Denmark',
    djibouti: 'Djibouti',
    dominica: 'Dominica',
    dominicanRepublic: 'Dominican Republic',
    ecuador: 'Ecuador',
    egypt: 'Egypt',
    elSalvador: 'El Salvador',
    equatorialGuinea: 'Equatorial Guinea',
    eritrea: 'Eritrea',
    estonia: 'Estonia',
    eswatini: 'Eswatini',
    ethiopia: 'Ethiopia',
    fiji: 'Fiji',
    finland: 'Finland',
    france: 'France',
    gabon: 'Gabon',
    gambia: 'Gambia',
    georgia: 'Georgia',
    germany: 'Germany',
    ghana: 'Ghana',
    greece: 'Greece',
    grenada: 'Grenada',
    guatemala: 'Guatemala',
    guinea: 'Guinea',
    guineaBissau: 'Guinea-Bissau',
    guyana: 'Guyana',
    haiti: 'Haiti',
    honduras: 'Honduras',
    hungary: 'Hungary',
    iceland: 'Iceland',
    india: 'India',
    indonesia: 'Indonesia',
    iran: 'Iran',
    iraq: 'Iraq',
    ireland: 'Ireland',
    israel: 'Israel',
    italy: 'Italy',
    jamaica: 'Jamaica',
    japan: 'Japan',
    jordan: 'Jordan',
    kazakhstan: 'Kazakhstan',
    kenya: 'Kenya',
    kiribati: 'Kiribati',
    kuwait: 'Kuwait',
    kyrgyzstan: 'Kyrgyzstan',
    laos: 'Laos',
    latvia: 'Latvia',
    lebanon: 'Lebanon',
    lesotho: 'Lesotho',
    liberia: 'Liberia',
    libya: 'Libya',
    liechtenstein: 'Liechtenstein',
    lithuania: 'Lithuania',
    luxembourg: 'Luxembourg',
    madagascar: 'Madagascar',
    malawi: 'Malawi',
    malaysia: 'Malaysia',
    maldives: 'Maldives',
    mali: 'Mali',
    malta: 'Malta',
    marshallIslands: 'Marshall Islands',
    mauritania: 'Mauritania',
    mauritius: 'Mauritius',
    mexico: 'Mexico',
    micronesia: 'Micronesia',
    moldova: 'Moldova',
    monaco: 'Monaco',
    mongolia: 'Mongolia',
    montenegro: 'Montenegro',
    morocco: 'Morocco',
    mozambique: 'Mozambique',
    myanmar: 'Myanmar',
    namibia: 'Namibia',
    nauru: 'Nauru',
    nepal: 'Nepal',
    netherlands: 'Netherlands',
    newZealand: 'New Zealand',
    nicaragua: 'Nicaragua',
    niger: 'Niger',
    nigeria: 'Nigeria',
    northKorea: 'North Korea',
    northMacedonia: 'North Macedonia',
    norway: 'Norway',
    oman: 'Oman',
    pakistan: 'Pakistan',
    palau: 'Palau',
    panama: 'Panama',
    papuaNewGuinea: 'Papua New Guinea',
    paraguay: 'Paraguay',
    peru: 'Peru',
    philippines: 'Philippines',
    poland: 'Poland',
    portugal: 'Portugal',
    qatar: 'Qatar',
    romania: 'Romania',
    russia: 'Russia',
    rwanda: 'Rwanda',
    saintKittsAndNevis: 'Saint Kitts and Nevis',
    saintLucia: 'Saint Lucia',
    saintVincentAndTheGrenadines: 'Saint Vincent and the Grenadines',
    samoa: 'Samoa',
    sanMarino: 'San Marino',
    saoTomeAndPrincipe: 'Sao Tome and Principe',
    saudiArabia: 'Saudi Arabia',
    senegal: 'Senegal',
    serbia: 'Serbia',
    seychelles: 'Seychelles',
    sierraLeone: 'Sierra Leone',
    singapore: 'Singapore',
    slovakia: 'Slovakia',
    slovenia: 'Slovenia',
    solomonIslands: 'Solomon Islands',
    somalia: 'Somalia',
    southAfrica: 'South Africa',
    southKorea: 'South Korea',
    southSudan: 'South Sudan',
    spain: 'Spain',
    sriLanka: 'Sri Lanka',
    sudan: 'Sudan',
    suriname: 'Suriname',
    sweden: 'Sweden',
    switzerland: 'Switzerland',
    syria: 'Syria',
    taiwan: 'Taiwan',
    tajikistan: 'Tajikistan',
    tanzania: 'Tanzania',
    thailand: 'Thailand',
    timorLeste: 'Timor-Leste',
    togo: 'Togo',
    tonga: 'Tonga',
    trinidadAndTobago: 'Trinidad and Tobago',
    tunisia: 'Tunisia',
    turkey: 'Turkey',
    turkmenistan: 'Turkmenistan',
    tuvalu: 'Tuvalu',
    uganda: 'Uganda',
    ukraine: 'Ukraine',
    unitedArabEmirates: 'United Arab Emirates',
    unitedKingdom: 'United Kingdom',
    unitedStates: 'United States',
    uruguay: 'Uruguay',
    uzbekistan: 'Uzbekistan',
    vanuatu: 'Vanuatu',
    vaticanCity: 'Vatican City',
    venezuela: 'Venezuela',
    vietnam: 'Vietnam',
    yemen: 'Yemen',
    zambia: 'Zambia',
    zimbabwe: 'Zimbabwe',
  },
};

export default en;
